// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TinymceController from "./tinymce_controller.js"
application.register("tinymce", TinymceController)

import AutocompleteController from "./autocomplete_controller.js"
application.register("autocomplete", AutocompleteController)

import ConditionalFormsController from "./conditional_forms_controller.js"
application.register("conditional_forms", ConditionalFormsController)

import FormsController from "./forms_controller.js"
application.register("forms", FormsController)
